import { pushEvent } from '../../client/data-layer';

export const trackCookieBannerIsVisible = (visible: boolean) => {
  pushEvent('cookieBannerIsVisible', { visible });
};
